export function readDarkModePreference() {
    try {
        const saved = localStorage.getItem('darkMode');
        if (saved === null || saved === '') {
            return false;
        }
        return JSON.parse(saved) === true;
    } catch {
        return false;
    }
}

export function persistDarkModePreference(enabled) {
    localStorage.setItem('darkMode', JSON.stringify(enabled === true));
}
